import { agentHubPaths } from '../../../util/constants';

/** Agent Hub provisioning routes, one sub-path per integration. */
export const provisioningPaths = {
  SHOPIFY: agentHubPaths.PROVISIONING_SHOPIFY,
  BIGCOMMERCE: agentHubPaths.PROVISIONING_BIGCOMMERCE,
  SQUARESPACE: agentHubPaths.PROVISIONING_SQUARESPACE,
} as const;

/** Store platforms that have a merchant-facing provisioning checklist. */
export type ProvisioningPlatform = 'shopify' | 'bigcommerce' | 'squarespace';

export const PROVISIONING_PATH_BY_PLATFORM: Record<ProvisioningPlatform, string> = {
  shopify: provisioningPaths.SHOPIFY,
  bigcommerce: provisioningPaths.BIGCOMMERCE,
  squarespace: provisioningPaths.SQUARESPACE,
};
